import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { Brand } from '../../../models/brand.model';
import { Location } from '@angular/common';
import { ModalComponent } from '../../../components/modal/modal.component';
import { CreateBrandComponent } from '../create-brand/create-brand.component';
import { BrandService } from '../brand.service';
import { PaginatorModule } from 'primeng/paginator';

@Component({
  selector: 'app-list-brand',
  imports: [
    CommonModule,
    TableModule,
    ButtonModule,
    ConfirmDialogModule,
    ToastModule,
    FormsModule,
    ModalComponent,
    CreateBrandComponent,
    PaginatorModule
  ],
  templateUrl: './list-brand.component.html'
})
export class ListBrandComponent implements OnInit {

  brandId!: number | null;
  searchTerm: string = '';
  totalRecords: number = 0;
  brands: Brand[] = [];
  loading: boolean = false;
  formVisible: boolean = false;

  first: number = 0;
  rows: number = 5;
  currentPage: number = 1;

  constructor(private location: Location, private brandService: BrandService) {}

  ngOnInit(): void {
    this.getData();
  }

  closeModal(){
    this.brandId = null;
  }

  getData(){
    this.brandService.getAll(this.searchTerm, null, true, this.currentPage).subscribe({
      next: (data) => {
        this.brands = data.data;
        this.totalRecords = data.pagination.totalRecords;
        this.loading = false;
      },
      error:(error) => {
        this.loading = false;
      }
    })
  }


   onPageChange(event: any){
    this.first = event.first;
    this.currentPage = Math.floor(this.first / this.rows) + 1;
    this.getData();
  }
  
  createBrand()
  {
    this.changeModal();
  }

  onFormSubmit() {
    this.changeModal();
    this.getData();
  }

  changeModal(){
    this.formVisible = !this.formVisible;
  }

  edit(brand: Brand){
    this.brandId = brand.id;
    this.changeModal();
  }

  goBack() {
    this.location.back();
  }
}
